import { Alert, Button, Card, Form } from "antd";
import Password from "antd/lib/input/Password";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import loginService from "../../services/loginService";
import MainLanding from "../../img/main-landing.png";

const ChangePasswordForm = () => {
  const history = useHistory();

  const [password, setPassword] = useState<string>();
  const [passwordRepeat, setPasswordRepeat] = useState<string>();
  const [saveFailed, setActionFailed] = useState<boolean>(false);
  const [hashNotValid, setHashNotValid] = useState<boolean>(false);
  const [passwordNotEqual, setPassNotEqual] = useState<boolean>(false);
  const [passwordTooShort, setPassTooShort] = useState<boolean>(false);
  const [apiCallInProgess, setApiCallInProgress] = useState<boolean>(false);

  //todo - move it to utils
  function getQueryVariable(variable: string) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return "";
  }

  const handleSubmit = async (event: React.FormEvent) => {
    //basic validations
    setPassTooShort(false);
    setPassNotEqual(false);
    if (password !== passwordRepeat) {
      setPassNotEqual(true);
      return;
    }

    if (password && password?.length < 5) {
      setPassTooShort(true);
      return;
    }

    setApiCallInProgress(true);

    //Check if link is valid - PLAN: move it to the load of page event
    const hash = getQueryVariable("passReset");
    const checkIsHashValidResult = await loginService.ValidatePassHash(hash);

    const isHashValid = checkIsHashValidResult.status === 200;

    if (!isHashValid) {
      setHashNotValid(true);
      setApiCallInProgress(false);
      return;
    }

    setHashNotValid(false);

    const changePassResult = await loginService.ChangePassword(password!, hash);

    // show that u can check .length if youre not sure what does the empty array means
    // is null or empty on array equivalent
    setApiCallInProgress(false);
    const changePassSuccess = changePassResult.status === 200;

    if (!changePassSuccess && changePassResult.statusText?.length > 0) {
      setActionFailed(true);
      return;
    }

    if (changePassSuccess) {
      setActionFailed(false);
      history.push("/changepasswordconfirm");
    } else {
      setActionFailed(true);
    }
  };

  return (
    <>
      <div className="landing-page">
        <img src={MainLanding} className="page-image" alt="" />
      </div>
      <div className="page-card">
        <Card className="page-card-element">
          <h1 className="recover-card-title">Reset password</h1>
          <Form
            name="basic"
            className="login-form"
            onChange={(e) => setActionFailed(false)}
            onFinish={(e) => handleSubmit(e)}
            layout="vertical"
          >
            <Form.Item
              className="page-card-form-item"
              label="New password"
              name="newpassword"
              rules={[
                { required: true, message: "Please provide new password!" },
              ]}
            >
              <Password
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />
            </Form.Item>

            <Form.Item
              className="page-card-form-item"
              label="Repeat new password"
              name="repeatnewpassword"
              rules={[
                { required: true, message: "Please repeat new password!" },
              ]}
            >
              <Password
                value={password}
                onChange={(e) => setPasswordRepeat(e.target.value)}
                type="password"
              />
            </Form.Item>

            <Form.Item
              className={
                saveFailed ||
                hashNotValid ||
                passwordNotEqual ||
                passwordTooShort
                  ? "page-card-form-item"
                  : "item-hidden"
              }
            >
              {saveFailed ? (
                <Alert message="Save Password Failed!" type="error" />
              ) : null}
              {hashNotValid ? (
                <Alert message="Link is expired or not valid!" type="error" />
              ) : null}
              {passwordNotEqual ? (
                <Alert message="Passwords do not match!" type="error" />
              ) : null}
              {passwordTooShort ? (
                <Alert message="Password too short!" type="error" />
              ) : null}
            </Form.Item>

            <Form.Item className="page-card-form-item recover-card-form-button">
              <Button
                type="primary"
                className="page-card-button"
                htmlType="submit"
                loading={apiCallInProgess}
              >
                {apiCallInProgess ? "" : "Save"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  );
};

ChangePasswordForm.displayName = "ChangePasswordForm";

export default ChangePasswordForm;
